import apiClient from '../../shared/services/apiClient';

/** 工单（客服）管理端：/api/admin/support/* */
const API_BASE = '/api/admin/support';

const fail = (error) => ({ status: 'error', msg: error.response?.data?.msg || error.message });
const get = (url, params) => apiClient.get(`${API_BASE}${url}`, { params }).then((r) => r.data).catch(fail);
const post = (url, data, config) => apiClient.post(`${API_BASE}${url}`, data, config).then((r) => r.data).catch(fail);

const supportAdminService = {
    getMeta: () => get('/meta'),
    getTickets: (params = {}) => get('/tickets', params),
    getTicket: (id) => get(`/tickets/${id}`),

    /** 单个附件的直传地址：{ name, size } → { url, key, headers, max_size } */
    getUploadUrl: (file) => post('/uploads', file),

    /** body, internal(bool), status, attachments(上传 key) */
    reply: (id, { body, internal, status, attachments = [] }) => post(`/tickets/${id}/reply`, {
        body: body || '',
        internal: internal ? 1 : 0,
        ...(!internal && status ? { status } : {}),
        attachments,
    }),
    update: (id, data) => post(`/tickets/${id}/update`, data),

    /** 附件需带登录凭证：blob 下载后用 object URL 触发保存 */
    async downloadAttachment(att) {
        try {
            const r = await apiClient.get(`${API_BASE}/attachments/${att.id}`, { responseType: 'blob' });
            const blob = r.data;
            if (blob && blob.type && blob.type.includes('application/json')) {
                const j = JSON.parse(await blob.text());
                return { status: 'error', msg: j.msg };
            }
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = att.filename || `attachment-${att.id}`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => URL.revokeObjectURL(url), 10000);
            return { status: 'success' };
        } catch (e) {
            return fail(e);
        }
    },

    getDepartments: () => get('/departments'),
    saveDepartment: (data) => post('/departments/save', data),
    deleteDepartment: (id) => post(`/departments/${id}/delete`),
    testDepartment: (id) => post(`/departments/${id}/test`),
};

export default supportAdminService;
